/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const GreenCircleTick = ({
  color = 'var(--positive)',
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M9 17.25A8.25 8.25 0 1 0 9 .75a8.25 8.25 0 0 0 0 16.5ZM9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        d="M13.249 6.443a.488.488 0 0 0-.69 0l-4.98 4.98-2.246-2.247a.488.488 0 0 0-.69.69l2.591 2.591c.19.19.5.19.69 0l5.325-5.324c.19-.19.19-.5 0-.69Z"
      />
    </svg>
  );
};

export default GreenCircleTick;
